export default "__VITE_ASSET__d89dd5c4__"